module.exports = __webpack_public_path__ + "static/media/search.152c511b.gif";